import * as React from 'react';
import './auth-layout.css';

export interface AuthCardProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Card wrapper for auth form content
 * Provides consistent spacing and styling
 */
export const AuthCard: React.FC<AuthCardProps> = ({ children, className }) => {
  return <div className={`auth-card ${className || ''}`}>{children}</div>;
};

AuthCard.displayName = 'AuthCard';
